export default __webpack_public_path__ + "static/media/profile.6d7b6e8d.svg";